import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "report-field" }

import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { bsonId } from "@/common/utils/common";

import type { FieldType } from "@/common/types/common";

import { baseInput, baseSelect } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'result-field',
  props: {
    data: {}
  },
  emits: ["update-data", "update-method"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const DEFAULT_PAYLOAD = {
  id: bsonId(),
  name: "",
  type: "",
  answer: "",
};

const payload = ref({ ...DEFAULT_PAYLOAD });

const typeOptions = computed(() => [
  {
    option: t("question.types.input"),
    value: "text",
  },
  {
    option: t("common.labels.number"),
    value: "number",
  },
]);

function update() {
  emit("update-data", payload.value);
}

onMounted(() => {
  if (props.data) {
    payload.value = {
      ...DEFAULT_PAYLOAD,
      ...props.data,
    };

    update();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_unref(baseSelect), {
      modelValue: payload.value.type,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((payload.value.type) = $event)),
      value: payload.value.type,
      options: typeOptions.value,
      "is-empty": false,
      onChange: _cache[1] || (_cache[1] = ($event: any) => (update()))
    }, {
      label: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)("common.labels.type")), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "value", "options"]),
    _createVNode(_unref(baseInput), {
      modelValue: payload.value.name,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((payload.value.name) = $event)),
      value: payload.value?.name,
      placeholder: _unref(t)('question.placeholders.name'),
      onBlur: _cache[3] || (_cache[3] = ($event: any) => (update()))
    }, {
      label: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)("common.labels.name")), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "value", "placeholder"])
  ]))
}
}

})